<template>

  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>
  <div class="cell small-12">
    <h1>Postponement</h1>
    <p>Upon becoming eligible to join the auto enrolment pension scheme, it is possible for an employer to postpone the employees enrolment into their pension scheme for up to three calendar months.</p>
    <p>This means that when an employee joins the company, starts to earn above the earnings threshold, or becomes eligible due to reaching their 22nd birthday, their enrolment can be delayed for three calendar months and then re-assessed for enrolment.</p>
  </div>
    <div class="cell small-8">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.applyPostponement">I would like to apply postponement<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.applyPostponement">I would like to enrol my employees as soon as they become eligible<span class="radiomark"></span></label>
      </form>
    </div>  




</template>


<script setup>

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';

const error = ref([]);
const route = useRoute();
const taskId = route.params.taskId;

const props = defineProps({
  formData: Object
})


const validateStep = () => {
  error.value = [];

  return true;
}


import { putDataCollectionTask } from '@/services/implementationmanagement.api';
const executeStep = async () => {

  var payload = {
    version: 1,
    dataJson: JSON.stringify(props.formData),
    schemaName: "CompanyAutoEnrolment",
    taskId: taskId,
    taskStatus: "SuccessfullyCompleted"
  }

  var response = await putDataCollectionTask(taskId, payload);

  if (response.status !== 200) {
    error.value = 'Error saving data. Please contact your Qtac account manager.';
    return false;
  }


  return true;
}



onMounted(() => {


});

defineExpose({ validateStep, executeStep });

</script>